import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';

/**
 * Lightweight client for Attach Document related APIs.
 * Note: backend must expose an endpoint like GET /api/i4u/attachdoc/presigned?key={key}
 */
@Injectable({
  providedIn: 'root'
})
export class AttachDocumentService extends BaseHttpService {
  private readonly ATTACH_ENDPOINT = 'i4u/attachdoc';

  constructor() {
    super();
  }

  /**
   * Request presigned URL for a stored key from the server.
   * Returns an absolute URL string when available.
   */
  getPresignedUrl(key: string): Observable<string> {
    return this.get<string>(`${this.ATTACH_ENDPOINT}/presigned?key=${encodeURIComponent(key)}`);
  }
}
